import {QuoteResponseDTO} from "@requests"
import {ref, Ref} from "vue"

const bookingQuoteResponse_edit: Ref<QuoteResponseDTO | null> = ref(null)

export default bookingQuoteResponse_edit